// extracted by mini-css-extract-plugin
export var EcommerceB2C = "index-module--EcommerceB2C--GSkXS";
export var Footer = "index-module--Footer--VAWCA";
export var TabBgColor = "index-module--TabBgColor--jRTm+";
export var TabShadow = "index-module--TabShadow--THWTZ";